"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _numberFormatter = require("../../helpers/numberFormatter");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./OrderListMobileExpandedComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('orders-list-expanded');
var renderTrade = function renderTrade(order, trades, decimalPlaces, context) {
  if (trades.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('no-data')
    }, context.t('No data is available'));
  }
  return trades.map(function (trade, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('trade-row'),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('trade-item')
    }, trade.TradeId), /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('trade-item')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('trade-item-value')
    }, (0, _numberFormatter.formatNumberToLocale)(trade.Quantity, decimalPlaces[order.product1Symbol])), /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('trade-item-product')
    }, order.product1Symbol)), /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('trade-item')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('trade-item-value')
    }, order.product2Symbol === 'USD' && '$', (0, _numberFormatter.formatNumberToLocale)(trade.Price, decimalPlaces[order.product2Symbol])), /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('trade-item-product')
    }, order.product2Symbol)), /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('trade-item')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('trade-item-value')
    }, order.product2Symbol === 'USD' && '$', (0, _numberFormatter.formatNumberToLocale)(trade.Quantity * trade.Price, decimalPlaces[order.product2Symbol])), /*#__PURE__*/_react["default"].createElement("div", {
      className: bemClasses('trade-item-product')
    }, order.product2Symbol)));
  });
};
var OrderListMobileExpandedComponent = function OrderListMobileExpandedComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var order = props.order,
    trades = props.trades,
    decimalPlaces = props.decimalPlaces;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('header')
  }, t('Order Details')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('order-row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('order-row-title')
  }, t('Order ID')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('order-row-value')
  }, order.orderId)), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('order-row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('order-row-title')
  }, t('Status')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('order-row-value')
  }, order.orderType)), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('order-row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('order-row-title')
  }, t('Date')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('order-row-value')
  }, order.dateTime)), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('order-row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('order-row-title')
  }, t('Notional')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('order-row-value')
  }, order.notional)), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('header')
  }, t('Trade Details')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('trade-header')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('trade-header-item')
  }, t('Trade ID')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('trade-header-item')
  }, t('Quantity')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('trade-header-item')
  }, t('Price')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('trade-header-item')
  }, t('Notional'))), renderTrade(order, trades, decimalPlaces, {
    t: t
  }));
};
var _default = exports["default"] = OrderListMobileExpandedComponent;